/**
****************************************************************************************
Project: Readabl
File: SelectionLayer.js
Description: This component will render selection layer.
© Healthcare Triangle, Inc
****************************************************************************************
**/

import { CheckCircle, RadioButtonUnchecked, Rotate90DegreesCcw } from "@mui/icons-material";
import React from "react";

const RotateLayer = (props) => {
    return (
         <div
            key={props.key}
            style={{
                width: props?.imageProps?.width,
                height: props.imageProps?.height,
                transform: `rotate(${360 - props.rotateAngle}deg)`
            }}
            className={`pdf-rotate-layer`}
        >
            <Rotate90DegreesCcw onClick={() => props.handleRotate(props.page)}/>
        </div>
    )
}

export default RotateLayer;